import React, { useEffect, useState } from "react";
import { Menu, X } from "lucide-react";
import logo from "../Assets/images/logo.svg";
import { Search } from "lucide-react";

const Header = ({ setShowModal }) => {
  const [isOpen, setIsOpen] = useState(false);

  useEffect(() => {
    if (isOpen) {
      document.body.style.overflow = "hidden";
    } else {
      document.body.style.overflow = "auto";
    }

    return () => {
      document.body.style.overflow = "auto";
    };
  }, [isOpen]);

  const navLinks = [
    { name: "Extension", href: "#" },
    { name: "Exploits", href: "#" },
    { name: "Learn", href: "#" },
    { name: "FAQ", href: "#" },
    { name: "Blog", href: "#" },
    { name: "Merchandise", href: "#" },
  ];

  return (
    <>
      <header className="top-0 z-50 bg-card/95 backdrop-blur">
        <div className="max-w-[1400px] mx-auto flex items-center justify-between h-16 md:h-20 px-4 sm:px-6 lg:px-8">
          {/* Logo */}
          <img src={logo} alt="Logo" className="h-7 md:h-8" />

          {/* Desktop Nav */}
          <nav className="items-center hidden gap-8 lg:flex">
            {navLinks.map((link) => (
              <a
                key={link.name}
                href={link.href}
                className="text-sm font-medium transition text-muted hover:text-primary"
              >
                {link.name}
              </a>
            ))}
          </nav>

          {/* Right Side */}
          <div className="flex items-center gap-3 md:gap-4">
            <button
              onClick={() => setShowModal(true)}
              className="px-4 py-2 text-xs font-semibold text-white transition bg-black rounded md:text-sm md:px-6 hover:scale-105"
            >
              Connect Wallet
            </button>

            {/* Mobile Menu Button */}
            <button className="md:hidden" onClick={() => setIsOpen(!isOpen)}>
              {isOpen ? <X size={26} /> : <Menu size={26} />}
            </button>
          </div>
        </div>

        {/* Mobile Menu */}
        {isOpen && (
          <div className="fixed inset-0 z-40 h-screen bg-white top-16 bg-card md:hidden">
            <div className="flex flex-col items-center gap-6 px-6 py-10 text-center">
              {navLinks.map((link) => (
                <a
                  key={link.name}
                  href={link.href}
                  onClick={() => setIsOpen(false)}
                  className="text-lg font-medium text-muted hover:text-primary"
                >
                  {link.name}
                </a>
              ))}
            </div>
          </div>
        )}

        <div className="mx-4 border-gray-400 border-y sm:mx-12">
          <div className="max-w-[1500px] mx-auto lg:px-1 py-1">
            <div className="relative flex items-center">
              {/* Icon */}
              <Search size={20} className="absolute left-3 text-muted" />

              {/* Input */}
              <input
                type="text"
                placeholder="Search Accounts by Address or Domain"
                className="w-full py-2 pl-10 pr-4 text-sm transition rounded-md outline-none md:text-base"
              />
            </div>
          </div>
        </div>
      </header>
    </>
  );
};

export default Header;
